import type { EventsControllerEvent } from '@platform/shared/rpc/node/api.gen';
import { EventsService } from '@platform/shared/rpc/node/api.gen';

type IEvent = {
    code: string | string[];
    id?: string;
    timestamp?: Date | number | string;
    source?: { tableName: string; schemaName?: string };
    payload: any;
};

export default {
    pushEvent(event: IEvent): Promise<void> {
        return EventsService.pushEvent({ body: event as EventsControllerEvent }).catch((err) =>
            console.warn('EventsServiceError', err)
        );
    },
    pushEvents(events: IEvent[]): Promise<void> {
        return EventsService.pushEvents({ body: events }).catch((err) => console.warn('EventsServiceError', err));
    },
};
